import React from 'react';

import DoubleArrowOutlinedIcon from '@mui/icons-material/DoubleArrowOutlined';
import { Button, Stack, Typography } from '@mui/material';
import { Translate } from 'react-jhipster';
import { sitemap } from 'app/shared/util/url-utils';
import { useNavigate } from 'react-router-dom';
import { WelcomeFormStepper } from './WelcomeFormStepper';

export const Welcome = () => {
  const navigate = useNavigate();

  const skipButtonClick = () => {
    navigate(sitemap.home);
  };

  return (
    <Stack textAlign="center">
      <Typography variant="h2" paddingTop={5}>
        <Translate contentKey="welcome.title" />
      </Typography>

      <Typography variant="subtitle2">
        <Translate contentKey="welcome.subtitle" />
      </Typography>

      <Typography variant="h3">
        <Translate contentKey="welcome.account-activation" />
      </Typography>

      <Typography variant="body1" mb={3}>
        <Translate contentKey="welcome.fill-details" />
      </Typography>

      <WelcomeFormStepper />

      <Button color="neutral" size="small" endIcon={<DoubleArrowOutlinedIcon />} onClick={skipButtonClick}>
        <Translate contentKey="welcome.skip-for-now" />
      </Button>
    </Stack>
  );
};
